module.exports = __webpack_public_path__ + "static/media/arrow.92839a67.png";